import { Component, OnInit } from "@angular/core";
import { FlightsService } from "../flights-calendar/flights.service";
import { InputModalityDetector } from "@angular/cdk/a11y";
import moment from "moment";
import { LocalStorageService } from "../shared/local-storage.service";
import { Helicopter } from "../shared/models/helicopter.model";
import { ExcelExportEvent } from "@progress/kendo-angular-grid";
import { SheetsBarComponent } from "@progress/kendo-angular-spreadsheet";
import { DatePipe } from "@angular/common";

@Component({
    selector: "app-aircraft-activity",
    standalone: false,
    templateUrl: "./aircraft-activity.component.html",
    styleUrl: "./aircraft-activity.component.scss",
})
export class AircraftActivityComponent implements OnInit {
    private _userSessionObject;

    public selectedDate: Date;

    public flightActivityList = [];
    public aircraftList: Helicopter[] = [];

    public today = new Date();

    constructor(
        private _flightsService: FlightsService,
        private _localStorageService: LocalStorageService,
        private _datePipe: DatePipe,
    ) {
        this._userSessionObject = this._localStorageService.getUserLocalStorageObject();
    }

    ngOnInit(): void {
        this._flightsService.getHelicoptersByOrgId(this._userSessionObject.organizationId.toString()).subscribe((aircrafts) => {
            this.aircraftList = aircrafts;
            this.selectedDate = new Date();
            this.onDateChange(this.selectedDate);
        });
    }

    public onDateChange(date: Date): void {
        const firstDay: Date = new Date(date.getFullYear(), date.getMonth(), 1);
        const lastDay: Date = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        this._flightsService.getHelicopterFlights(moment(firstDay).format("YYYY-MM-DD"), moment(lastDay).format("YYYY-MM-DD"), null).subscribe((flights) => {
            this.flightActivityList = [];
            const currentDate = new Date(firstDay);

            while (currentDate <= lastDay) {
                const activityEntry = new Map();
                activityEntry.set("day", this._datePipe.transform(currentDate, "EEE"));
                activityEntry.set("date", moment(currentDate).format("DD/MM/YYYY"));

                flights
                    .filter((flight) => moment(flight.flightDate).isSame(moment(currentDate), "day"))
                    .forEach((flight) => {
                        activityEntry.set("_" + flight.helicopterId, { hasFlight: true });
                    });
                this.flightActivityList.push(Object.fromEntries(activityEntry));

                currentDate.setDate(currentDate.getDate() + 1);
            }
        });
    }

    public countOccurrences(field: string, value: boolean): number {
        return this.flightActivityList.reduce((count, row) => {
            return row[field]?.hasFlight === value ? count + 1 : count;
        }, 0);
    }

    public getFileName(): string {
        return "Aircraft_Activity_" + moment(this.selectedDate).format("MMMM_YYYY") + ".xlsx";
    }

    onExcelExport(e: ExcelExportEvent) {
        const rows = e.workbook.sheets[0].rows;

        // set alternating row color
        let altIdx = 0;
        rows.forEach((row) => {
            if (row.type === "data") {
                if (altIdx % 2 !== 0) row.cells.forEach((cell) => (cell.background = "#f2f7ff"));
                altIdx++;
                row.cells.forEach((cell) => {
                    if (cell.value?.hasFlight) {
                        cell.value = "✓";
                        cell.color = "#ffffff";
                        cell.background = "#4050b5";
                        cell.textAlign = "center";
                    } else if (cell.value === undefined) {
                        cell.value = "✗";
                        cell.background = "#ffee00";
                        cell.textAlign = "center";
                    }
                });
            }
        });

        const footerRowIndex = rows.findIndex((row) => row.type === "footer");
        const baseFooter = rows[footerRowIndex];
        const falseFooterRow = JSON.parse(JSON.stringify(baseFooter));

        baseFooter.cells.forEach((cell, index) => {
            if (cell.value) {
                const parts: string[] = cell.value.trim().split(/\s+/);
                cell.value = Number(parts[0]);
                falseFooterRow.cells[index].value = Number(parts[1]);
                cell.color = "#ffffff";
                cell.background = "#4050b5";
                cell.textAlign = "center";
                falseFooterRow.cells[index].background = "#ffee00";
                falseFooterRow.cells[index].textAlign = "center";
            } else {
                if (index === 0) {
                    cell.value = "Totals:";
                    cell.color = "#ffffff";
                }
                cell.background = "#4050b5";
                falseFooterRow.cells[index].background = "#ffee00";
            }
        });

        e.workbook.sheets[0].rows.push(falseFooterRow);
    }
}
